import React from "react";
import './Category.css'
function Category() {
    return(
        <div className="header-category">
            <span>Mens</span>
            <span>Women</span>
            <span>Sports</span>
            <span>Kids</span>
            <span>Sneakers</span>
            <span>Running Shoes</span>
            <span>Accessories</span>
        </div>
    )    
}

export default Category;